import request from "@/utils/request.js";
import { YuliStaking } from "./config.js";
import _ from "lodash";

/**
 * 获取钱包资产
 * @returns
 */
export const getUserProps = () => {
  return request.get(YuliStaking.getUserProps);
};

/**
 * 获取钱包资产
 * @returns
 */
export const getWallet = () => {
  return request.get(YuliStaking.getWallet);
};

/**
 * 获取Yuli列表
 * @returns
 */
export const getYuliList = () => {
  return request.get(YuliStaking.getYuliList);
};

/**
 * 获取二代质押记录
 * @returns
 */
export const getYOG2StakingRecord = () => {
  return request.get(YuliStaking.getYog2StakingRecord);
};

/**
 * 创建二代Yuli质押
 * @param {*} params
 */
export const postYOG2StakingRecord = (params) => {
  return request.post(YuliStaking.postYog2StakingRecord, params);
};

/**
 * 二代Yuli赎回
 * @param {*} params
 */
export const postYOG2StakingRedeem = (id, params) => {
  return request.post(`/api/p/v2/yog2_staking/records/${id}/redeem`, params);
};

/**
 * 二代Yuli续期
 * @param {*} params
 */
export const postYOG2StakingRenew = (id, params) => {
  return request.post(`/api/p/v2/yog2_staking/records/${id}/renew`, params);
};
